import { int } from "@goodgamestudios/math-utilities";

import { BasicDialogProperties } from "../../../basic/view/dialogs/BasicDialogProperties";

import { PlayerProfileVO } from "../../gamevo/PlayerProfileVO";

export class Poker2ProfilDialogProperties extends BasicDialogProperties {
    public static TAB_ACHIEVEMENTS: number = 1;
    public static TAB_STATISTICS: number = 2;

    public tabIndex: number = 0;
    public playerId: number = 0;
    public playerProfile: PlayerProfileVO;
    public achievementPointsTotal: number = 0;

    constructor(tabIndex: number, playerId: number, playerProfilParameter: any) {
        super();

        this.tabIndex = tabIndex;
        this.playerId = playerId;

        if (playerProfilParameter) {
            this.parse_GPP(playerProfilParameter);
        }
    }

    private parse_GPP(paramObject: any): void {
        this.playerProfile = new PlayerProfileVO();
        if (!paramObject)
            return;
        this.playerId = int(paramObject.playerId);
        this.playerProfile.bonus = int(paramObject.bonus);
        this.playerProfile.giftsSend = paramObject.giftsSend;
        this.playerProfile.giftsReceived = paramObject.giftsReceived;
        this.playerProfile.fInvited = int(paramObject.fInvited);
        this.playerProfile.gamesPlayed = int(paramObject.gamesPlayed);
        this.playerProfile.wins = paramObject.wins;
        this.playerProfile.pTime = paramObject.pTime;
        this.playerProfile.pTimeSession = paramObject.pTimeSession;
        this.playerProfile.bestHand = int(paramObject.bestHand);
        this.playerProfile.winLoss = paramObject.winLoss;
        this.playerProfile.winningStreak = int(paramObject.winningStreak);
        this.playerProfile.loosingStreak = int(paramObject.loosingStreak);
        this.playerProfile.tPlayed = int(paramObject.tPlayed);
        this.playerProfile.tWon = int(paramObject.tWon);
        this.playerProfile.tFinalTable = int(paramObject.tFinalTable);
        this.playerProfile.tWonChips = paramObject.tWonChips;
        this.playerProfile.tWonGold = paramObject.tWonGold;
        this.playerProfile.playerStats = paramObject.playerStats;

        if (paramObject.B)
            this.playerProfile.booster = paramObject.B;
        else
            this.playerProfile.booster = [];
    }

}
